import { FocusEventHandler, memo } from 'react';
import '../styles.css';
import { SearchIconThin } from 'src/components/svg/Searches';
import { Input } from '../Input';
import { useTranslation } from 'react-i18next';

interface InputSearchProps {
  value: string | undefined;
  onChange: (value: string) => void;
  onClick?: () => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  placeholder: string;
}

const _InputSearch = ({ value, onChange, onClick, onBlur, placeholder }: InputSearchProps) => {
  const { t } = useTranslation();
  return (
    <Input
      onBlur={onBlur}
      value={value}
      onClick={onClick}
      onChange={(e) => onChange(e.target.value)}
      leftIcon={<SearchIconThin className="pr-2" />}
      // overrideContainerClassName="gap-0 w-full"
      placeholder={t(placeholder) as string}
    />
  );
};

export const InputSearch = memo(_InputSearch);
